
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1wiCI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5RH40 = parcelRequire("5RH40");


var $6rfCL = parcelRequire("6rfCL");

const $03fea7d8755c9f3e$export$ba727134bfb13dd3 = ({ extensionNode: extensionNode, contentId: contentId, mode: mode })=>{
    const { parameters: parameters } = extensionNode || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5RH40.HubExtensionsWrapper), {
        mode: mode,
        extensionNode: extensionNode,
        contentId: contentId,
        showNoDataState: !parameters,
        packageName: "links-menu-extension"
    }, extensionNode && (0, $6rfCL.extensionHasParams)(extensionNode) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6rfCL.LinksMenuContent), {
        contentId: contentId,
        extensionNode: extensionNode,
        isInEditor: true
    }) : null);
};
const $03fea7d8755c9f3e$export$f3053e92898af37 = ({ propsProvider: PropsProvider, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PropsProvider, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($03fea7d8755c9f3e$export$ba727134bfb13dd3, props));
module.exports["LinksMenuExtensionInner"] = $03fea7d8755c9f3e$export$ba727134bfb13dd3;
module.exports["LinksMenuExtension"] = $03fea7d8755c9f3e$export$f3053e92898af37;

});

parcelRegister("5RH40", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $a1L5E = parcelRequire("a1L5E");


var $cfM7x = parcelRequire("cfM7x");


var $hjUDQ = parcelRequire("hjUDQ");


var $d6u4w = parcelRequire("d6u4w");


var $3eDML = parcelRequire("3eDML");


var $ame4Z = parcelRequire("ame4Z");


var $2t092 = parcelRequire("2t092");

const $c10f9c6572a37e37$export$1b8348eac06ebe09 = ({ extensionNode: extensionNode, contentId: contentId, analyticsAttributes: analyticsAttributes, children: children, showNoDataState: showNoDataState, mode: mode = (0, $hjUDQ.ExtensionMode).RENDERER, packageName: packageName })=>{
    const { analyticsContext: analyticsContext, errorBoundaryComponent: errorBoundaryComponent, experienceStartComponent: experienceStartComponent } = (0, $cfM7x.useProductDependencies)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { extensionKey: extensionKey, parameters: parameters } = extensionNode || {};
    const hasParameters = !showNoDataState || parameters;
    const ExperienceStart = experienceStartComponent || (0, $cozmU.Fragment);
    const ErrorBoundaryComponent = errorBoundaryComponent || (0, $ame4Z.HubErrorBoundary);
    const errorBoundaryProps = errorBoundaryComponent ? {} : {
        id: extensionKey ?? contentId,
        packageName: packageName,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eDML.GenericErrorPage), null)
    };
    (0, $cozmU.useEffect)(()=>{
        if (mode === (0, $hjUDQ.ExtensionMode).RENDERER) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'macro',
                actionSubjectId: extensionKey,
                source: 'viewPageScreen',
                attributes: {
                    ...analyticsAttributes,
                    ...analyticsContext,
                    hasParameters: !!parameters,
                    contentId: contentId
                }
            }
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: extensionKey || 'unknown-hub-extension'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ErrorBoundaryComponent, {
        ...errorBoundaryProps,
        shouldForceError: (0, $2t092.EXTENSIONS_CRITICAL_FOR_PAGE_LOAD).has(extensionKey || '')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceStart, null), hasParameters ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6u4w.NoExtensionData), {
        source: extensionKey
    })));
};
module.exports["HubExtensionsWrapper"] = $c10f9c6572a37e37$export$1b8348eac06ebe09;

});

parcelRegister("d6u4w", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $RfroO = parcelRequire("RfroO");


var $iMnC5 = parcelRequire("iMnC5");


var $cfM7x = parcelRequire("cfM7x");


var $iP3ib = parcelRequire("iP3ib");


var $icRfg = parcelRequire("icRfg");

const $f11bc349985cedb8$var$styles = {
    baseStyles: "_1e0c1txw _1bah1h6o _4cvr1h6o",
    configPanelStyles: "_4t3i1vuk",
    extensionStyles: "_4t3i1osq"
};
const $f11bc349985cedb8$export$dd91c9257a0f1cd4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { source: t1, isConfigPanel: isConfigPanel } = t0;
    const source = t1 === undefined ? "" : t1;
    const intl = (0, $kSwu1.useIntl)();
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    let t2;
    if ($[0] !== source) {
        t2 = source?.charAt(0).toUpperCase();
        $[0] = source;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== source) {
        t3 = source?.slice(1);
        $[2] = source;
        $[3] = t3;
    } else t3 = $[3];
    const extensionSourceName = t2 + t3;
    let t4;
    let t5;
    if ($[4] !== extensionSourceName || $[5] !== isConfigPanel || $[6] !== submitError) {
        t4 = ()=>{
            const errorMessage = `${extensionSourceName} ${isConfigPanel ? "config panel" : "extension"} failed to render. No parameters.`;
            submitError?.(new Error(errorMessage));
        };
        t5 = [
            extensionSourceName,
            isConfigPanel,
            submitError
        ];
        $[4] = extensionSourceName;
        $[5] = isConfigPanel;
        $[6] = submitError;
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, $cozmU.useEffect)(t4, t5);
    const t6 = isConfigPanel ? $f11bc349985cedb8$var$styles.configPanelStyles : $f11bc349985cedb8$var$styles.extensionStyles;
    let t7;
    if ($[9] !== t6) {
        t7 = (0, $w6R6I.cx)($f11bc349985cedb8$var$styles.baseStyles, t6);
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== intl) {
        t8 = intl.formatMessage((0, $icRfg.messages).noDataStateHeaderText);
        $[11] = intl;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $icRfg.messages).noDataStateDescription);
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
            header: t8,
            description: t9,
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($iP3ib)))
        });
        $[14] = t8;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== t10 || $[17] !== t7) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t7
        }, t10);
        $[16] = t10;
        $[17] = t7;
        $[18] = t11;
    } else t11 = $[18];
    return t11;
} : ({ source: source = '', isConfigPanel: isConfigPanel })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const extensionSourceName = source?.charAt(0).toUpperCase() + source?.slice(1);
    (0, $cozmU.useEffect)(()=>{
        const errorMessage = `${extensionSourceName} ${isConfigPanel ? 'config panel' : 'extension'} failed to render. No parameters.`;
        submitError?.(new Error(errorMessage));
    }, [
        extensionSourceName,
        isConfigPanel,
        submitError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($f11bc349985cedb8$var$styles.baseStyles, isConfigPanel ? $f11bc349985cedb8$var$styles.configPanelStyles : $f11bc349985cedb8$var$styles.extensionStyles)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
        header: intl.formatMessage((0, $icRfg.messages).noDataStateHeaderText),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $icRfg.messages).noDataStateDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($iP3ib)))
    }));
};
module.exports["NoExtensionData"] = $f11bc349985cedb8$export$dd91c9257a0f1cd4;

});

parcelRegister("iP3ib", function(module, exports) {
module.exports = new URL("Warning.e56d4e3e.svg", import.meta.url).toString();

});

parcelRegister("icRfg", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $8e4fbaddba5526c6$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    noDataStateHeaderText: {
        id: "company-hub.company-hub-common.link-cards.error-states.no-data.header-text",
        defaultMessage: "No data to display"
    },
    noDataStateDescription: {
        id: "company-hub.company-hub-common.link-cards.error-states.no-data.description-text",
        defaultMessage: "Try deleting this macro and creating a new one."
    }
});
module.exports["messages"] = $8e4fbaddba5526c6$export$defe85febe8b728c;

});

parcelRegister("2t092", function(module, exports) {
// we have made a copy of the extension keys to avoid importing the constants from the extensions packages
// this is a temporary solution to avoid the bundle size increase
// todo: we will have to create a new package for the constants and import it here
const $123f2f203b618ce4$export$3617e2677e53ded6 = new Set([
    'links-menu',
    'cards',
    'spotlight',
    'carousel',
    'hub-section',
    'jsm-help'
]);
module.exports["EXTENSIONS_CRITICAL_FOR_PAGE_LOAD"] = $123f2f203b618ce4$export$3617e2677e53ded6;

});

parcelRegister("6rfCL", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $jIDse = parcelRequire("jIDse");


var $cfM7x = parcelRequire("cfM7x");


var $eafQX = parcelRequire("eafQX");


var $4WDWC = parcelRequire("4WDWC");


var $hjUDQ = parcelRequire("hjUDQ");


var $8Yw12 = parcelRequire("8Yw12");

const $3854be2903fd20e9$var$ALIGNMENT_MAP = {
    [(0, $8Yw12.ALIGNMENT).LEFT]: 'flex-start',
    [(0, $8Yw12.ALIGNMENT).CENTER]: 'center',
    [(0, $8Yw12.ALIGNMENT).RIGHT]: 'flex-end'
};
const $3854be2903fd20e9$var$getBorder = (color)=>`${"var(--ds-border-width-selected, 2px)"} solid ${color}`;
const $3854be2903fd20e9$var$getBorderStyles = (color)=>({
        [(0, $8Yw12.BORDER).NONE]: {},
        [(0, $8Yw12.BORDER).ALL_SIDES]: {
            border: $3854be2903fd20e9$var$getBorder(color)
        },
        [(0, $8Yw12.BORDER).BOTTOM]: {
            borderBottom: $3854be2903fd20e9$var$getBorder(color)
        }
    });
const $3854be2903fd20e9$var$CORNERS_MAP = {
    [(0, $8Yw12.CORNERS).ROUND]: "var(--ds-radius-small, 4px)",
    [(0, $8Yw12.CORNERS).SHARP]: 'unset'
};
// Map the links-menu-local CORNERS enum onto the shared CornerStyle enum so the
// common resolveCornerRadiusOverride helper can be reused (SHARP → SQUARED,
// ROUND → ROUNDED).
const $3854be2903fd20e9$var$CORNERS_TO_CORNER_STYLE = {
    [(0, $8Yw12.CORNERS).ROUND]: (0, $hjUDQ.CornerStyle).ROUNDED,
    [(0, $8Yw12.CORNERS).SHARP]: (0, $hjUDQ.CornerStyle).SQUARED
};
/**
 * Resolve the container corner styling.
 *
 * When the hub corner-radius gate is OFF the legacy behaviour is preserved
 * verbatim: `CORNERS.ROUND → radius.small`, `CORNERS.SHARP → unset`.
 *
 * When the gate is ON the container follows the hub-wide `--hub-corner-radius`
 * (symmetric with the spotlight/carousel treatment). An explicit numeric
 * `cornerRadius` (from the config slider) wins and pins a local override
 * (`0` is preserved as truly square); otherwise the legacy `cornerStyle` enum is
 * mapped (`SHARP` → `0`, `ROUND` → inherit the hub value).
 */ const $3854be2903fd20e9$var$getCornerStyling = (cornerStyle, cornerRadius, isCornerRadiusEnabled)=>{
    if (!isCornerRadiusEnabled) return {
        borderRadius: $3854be2903fd20e9$var$CORNERS_MAP[cornerStyle]
    };
    const override = (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, $3854be2903fd20e9$var$CORNERS_TO_CORNER_STYLE[cornerStyle]);
    return {
        borderRadius: `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`,
        ...typeof override === 'number' ? {
            [(0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR)]: `${(0, $4WDWC.resolveHubCornerRadius)(override)}px`
        } : {}
    };
};
const $3854be2903fd20e9$export$4a96f3bbfd95cbd4 = (styles, isCornerRadiusEnabled = false)=>{
    const { alignment: alignment, fillColor: fillColor, borderColor: borderColor, border: border, cornerStyle: cornerStyle, cornerRadius: cornerRadius } = styles;
    return {
        justifyContent: $3854be2903fd20e9$var$ALIGNMENT_MAP[alignment],
        backgroundColor: fillColor,
        ...$3854be2903fd20e9$var$getBorderStyles(borderColor)[border],
        ...$3854be2903fd20e9$var$getCornerStyling(cornerStyle, cornerRadius, isCornerRadiusEnabled)
    };
};






var $55fM8 = parcelRequire("55fM8");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $1LXnB = parcelRequire("1LXnB");




/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 






var $4nIKB = parcelRequire("4nIKB");


var $9DHhW = parcelRequire("9DHhW");


var $3vgx3 = parcelRequire("3vgx3");

var $is1T6 = parcelRequire("is1T6");

var $9erVg = parcelRequire("9erVg");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $hBYtq = parcelRequire("hBYtq");





var $bQmwQ = parcelRequire("bQmwQ");




const $922a12df372d5d84$var$triggerStyles = {
    firstItem: "_2rko12b0 _zulpu2gc _4cvr1h6o _bfhksm61 _1e0c1txw _1tkezwfg _irr31dpa",
    firstItemSelected: "_2rko12b0 _zulpu2gc _4cvr1h6o _bfhk1dpa _1e0c1txw _1tkezwfg",
    dropdownItem: "_bfhk1dpa"
};
const $922a12df372d5d84$var$selectedDropdownItemStyles = null;
const $922a12df372d5d84$var$displayTextStyles = null;
const $922a12df372d5d84$var$firstItemStyles = null;
const $922a12df372d5d84$var$NestedLinkItem = ({ childItemId: childItemId, childTitle: childTitle, link: link })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { useAnalyticsActions: useAnalyticsActions } = (0, $cfM7x.useProductDependencies)();
    const analytics = useAnalyticsActions?.useLinkAnalyticActions?.(link);
    (0, $cozmU.useEffect)(()=>{
        analytics?.handleView?.();
    }, [
        analytics,
        analytics?.handleView
    ]);
    const handleLinkItemClick = ()=>{
        analytics?.handleClick?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link item',
                source: (0, $bQmwQ.LINKS_MENU_EXTENSION_ANALYTIC_SOURCE)
            }
        }).fire();
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $is1T6.default), {
        key: childItemId,
        href: link,
        onClick: handleLinkItemClick,
        target: "_blank"
    }, childTitle);
};
const $922a12df372d5d84$export$2ce376c2cc3355c8 = ({ index: index, itemId: itemId, title: title, childItems: childItems, isFirstItem: isFirstItem, highlightColor: highlightColor, textColor: textColor, setWidth: setWidth })=>{
    const ref = (0, $cozmU.useRef)(null);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (setWidth && ref.current) setWidth(ref.current.offsetWidth, index);
         // if item title updates, trigger a width recalculation
    }, [
        setWidth,
        index,
        title
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireUIAnalytic = ()=>createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'menu item',
                source: (0, $bQmwQ.LINKS_MENU_EXTENSION_ANALYTIC_SOURCE)
            }
        }).fire();
    return(// TODO: Add `shouldRenderToParent` to resolve accessibility issues. See https://a11y.atlassian.net/browse/JCATS-788
    /*#__PURE__*/ $cozmU.createElement((0, $3vgx3.default), {
        placement: isFirstItem ? 'bottom-start' : 'right-start',
        shouldFlip: !isFirstItem,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>isFirstItem ? /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
                ...triggerProps,
                key: itemId,
                ref: (0, $4nIKB.mergeRefs)([
                    triggerRef,
                    ref
                ]),
                xcss: triggerProps['aria-expanded'] ? $922a12df372d5d84$var$triggerStyles.firstItemSelected : $922a12df372d5d84$var$triggerStyles.firstItem,
                onClick: (e)=>{
                    triggerProps.onClick?.(e);
                    fireUIAnalytic();
                }
            }, /*#__PURE__*/ $cozmU.createElement("span" /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values */ , {
                style: {
                    color: triggerProps['aria-expanded'] ? highlightColor : textColor
                },
                className: (0, $hekY6.default)([
                    "_11c8fhey _k48p1wq8",
                    "_1reo15vq _18m915vq _1e0c1ule _p12fuuw1 _1bto1l2s _o5721q9c"
                ])
            }, title), /*#__PURE__*/ $cozmU.createElement("div", {
                style: {
                    color: triggerProps['aria-expanded'] ? highlightColor : textColor
                }
            }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "dropdown-expand",
                size: "small"
            }))) : /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    "_1i071dpa _16c3n7od _1eq6glyw"
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $is1T6.default), {
                ...triggerProps,
                elemAfter: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: "dropdown-expand",
                    size: "small"
                }),
                key: itemId,
                ref: triggerRef,
                onClick: (e)=>{
                    triggerProps.onClick?.(e);
                    fireUIAnalytic();
                }
            }, /*#__PURE__*/ $cozmU.createElement("span", {
                className: (0, $hekY6.default)([
                    "_1reo15vq _18m915vq _1e0c1ule _p12fuuw1 _1bto1l2s _o5721q9c"
                ])
            }, title)))
    }, /*#__PURE__*/ $cozmU.createElement((0, $9erVg.default), null, childItems?.map((item)=>{
        const { itemId: childItemId, title: childTitle, type: type } = item;
        if (type === (0, $8Yw12.ITEM).MENU) return /*#__PURE__*/ $cozmU.createElement($922a12df372d5d84$export$2ce376c2cc3355c8, {
            key: childItemId,
            title: childTitle,
            childItems: item.childItems
        });
        const { link: link } = item;
        return /*#__PURE__*/ $cozmU.createElement($922a12df372d5d84$var$NestedLinkItem, {
            key: childItemId,
            childItemId: childItemId,
            childTitle: childTitle,
            link: link
        });
    }))));
};


/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 






var $eKMV3 = parcelRequire("eKMV3");







const $9ca3d53268575801$export$68ef190193a37bc2 = ({ index: index, itemId: itemId, link: link, textColor: textColor, title: title, setWidth: setWidth })=>{
    const ref = (0, $cozmU.useRef)(null);
    const { useAnalyticsActions: useAnalyticsActions } = (0, $cfM7x.useProductDependencies)();
    (0, $cozmU.useLayoutEffect)(()=>{
        if (setWidth && ref.current) setWidth(ref.current.offsetWidth, index);
         // if item title updates, trigger a width recalculation
    }, [
        setWidth,
        index,
        title
    ]);
    const analytics = useAnalyticsActions?.useLinkAnalyticActions?.(link);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hasFiredView = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!hasFiredView.current && analytics?.handleView) {
            analytics.handleView();
            hasFiredView.current = true;
        }
    }, [
        analytics,
        analytics?.handleView
    ]);
    const handleLinkButtonClick = ()=>{
        analytics?.handleClick?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link item',
                source: (0, $bQmwQ.LINKS_MENU_EXTENSION_ANALYTIC_SOURCE)
            }
        }).fire();
    };
    const href = link || undefined;
    return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        appearance: "subtle",
        target: "_blank",
        href: href,
        id: itemId,
        ref: ref,
        onClick: handleLinkButtonClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span" /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values */ , {
        style: {
            color: textColor
        }
    }, title)) : null;
};





const $a9637bc5784c4101$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    moreItemTitle: {
        id: "company-hub.links-menu-extension.links-menu-content.links-menu-items.more.title",
        defaultMessage: "More"
    }
});


const $c2cb3287f5634ca1$var$APPROX_OVERFLOW_BUTTON_WIDTH = 100;
const $c2cb3287f5634ca1$var$APPROX_MIN_PADDING_INLINE = 48;
function $c2cb3287f5634ca1$var$howManyTabsFit(individualTabWidths, availableWidth) {
    let numberTabs = 0, totalWidthTabs = 0;
    for(let i = 0; i < individualTabWidths.length; i++){
        totalWidthTabs += individualTabWidths[i];
        if (totalWidthTabs > availableWidth) break;
        numberTabs++;
    }
    return {
        numberTabs: numberTabs
    };
}
function $c2cb3287f5634ca1$var$newItemTabWidthsRef() {
    const current = new Array();
    return {
        current: current,
        // Identifies to React Compiler that the reactive state is the opaque value "item tab widths ref", its internal mutations are purposefully not reactive
        setItemTabWidth (index, tabWidth) {
            current[index] = tabWidth;
        }
    };
}
const $c2cb3287f5634ca1$export$4501b8c967503aa = ({ highlightColor: highlightColor, items: items, textColor: textColor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [maxLinksMenuTabs, setMaxLinksMenuTabs] = (0, $cozmU.useState)(items?.length || 0);
    const itemTabWidthsOld = (0, $cozmU.useRef)([]);
    // `itemTabWidths` used to be a `useRef`, but that turned out to be insufficienlty reactive, re-calculations were not triggered though were necessary.
    // `useState` allows for more control over hook re-executions and rerenders than `useRef`,
    // while `newItemTabWidthsRef` allows for preventing unnecessary hook re-executions and re-renders upon `handleSetWebItemTabWidth`.
    const [itemTabWidthsNew, setItemTabWidths] = (0, $cozmU.useState)($c2cb3287f5634ca1$var$newItemTabWidthsRef);
    const itemTabWidths = (0, $iDrrr.fg)('pcs-3808077-links-menu-react-compiler-fixes') ? itemTabWidthsNew : itemTabWidthsOld;
    const [width, setWidth] = (0, $cozmU.useState)(0);
    (0, $cozmU.useLayoutEffect)(()=>{
        // calculate how many tabs fit given current width on first render, and on resize
        const availableWidth = Math.max(width - $c2cb3287f5634ca1$var$APPROX_OVERFLOW_BUTTON_WIDTH - 2 * $c2cb3287f5634ca1$var$APPROX_MIN_PADDING_INLINE, 0);
        if (availableWidth) {
            const { numberTabs: numberTabs } = $c2cb3287f5634ca1$var$howManyTabsFit(itemTabWidths.current, availableWidth);
            setMaxLinksMenuTabs(numberTabs);
        }
    // run this calculation also when maxLinksMenuTabs updates
    }, [
        itemTabWidths,
        width,
        maxLinksMenuTabs
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Handle when `items` updates, eg link or menu items are added or removed in config panel and
        // we need to recalculate width.
        // Reset itemTabWidths to empty when `items` updates so that we can calculate all widths from
        // scratch, otherwise adding/deleting items can cause the widths array to fall out of sync as
        // elements move indexes in the items array
        if ((0, $iDrrr.fg)('pcs-3808077-links-menu-react-compiler-fixes')) setItemTabWidths($c2cb3287f5634ca1$var$newItemTabWidthsRef);
        else itemTabWidthsOld.current = [];
        // Resetting max # of tabs here will cause a brief rendering of ALL tabs and they will all call the
        // setWidth callback and update itemTabWidths array with their respective widths.
        // A new value for maxLinksMenuTabs will also cause useLayoutEffect to rerun, recalculate available width,
        // and reset maxLinksMenuTabs again which will send tabs that can't fit to the overflow menu.
        setMaxLinksMenuTabs(items?.length || 0);
    }, [
        items
    ]);
    const handleSetWebItemTabWidthNew = (0, $cozmU.useCallback)((tabWidth, index)=>{
        if (index != null) itemTabWidthsNew.setItemTabWidth(index, tabWidth);
    }, [
        itemTabWidthsNew
    ]);
    if (!items) return null;
    const handleSetWebItemTabWidthOld = (tabWidth, index)=>{
        if (index != null) itemTabWidthsOld.current[index] = tabWidth;
    };
    const handleSetWebItemTabWidth = (0, $iDrrr.fg)('pcs-3808077-links-menu-react-compiler-fixes') ? handleSetWebItemTabWidthNew : handleSetWebItemTabWidthOld;
    const onResize = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(setWidth, 100, {
        leading: false
    });
    const isOverflowDetected = items.length > maxLinksMenuTabs;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, items?.slice(0, maxLinksMenuTabs).map((item, index)=>{
        const { itemId: itemId, type: type, title: title } = item;
        if (type === (0, $8Yw12.ITEM).MENU) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $922a12df372d5d84$export$2ce376c2cc3355c8), {
            index: index,
            key: index,
            title: title,
            childItems: item.childItems,
            highlightColor: highlightColor,
            textColor: textColor,
            isFirstItem: true,
            setWidth: handleSetWebItemTabWidth
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ca3d53268575801$export$68ef190193a37bc2), {
            index: index,
            itemId: itemId,
            key: index,
            link: item.link,
            textColor: textColor,
            title: title,
            setWidth: handleSetWebItemTabWidth
        });
    }), isOverflowDetected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $922a12df372d5d84$export$2ce376c2cc3355c8), {
        title: formatMessage((0, $a9637bc5784c4101$export$defe85febe8b728c).moreItemTitle),
        childItems: items?.slice(maxLinksMenuTabs - items.length),
        highlightColor: highlightColor,
        textColor: textColor,
        isFirstItem: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.default), {
        setWidth: onResize
    }));
};


const $5f731770152f321b$export$9ffe29f134ccd6e9 = (extensionNode)=>{
    return !!extensionNode.parameters;
};
const $5f731770152f321b$var$defaultStyles = {
    itemsWrapper: "_zulpu2gc _18zroahv _1e0c11p5 _wij21bp4 _ca0qutpp _n3tdutpp _1bah1h6o _1ul953f4",
    editorStyles: "_19pk1b66 _2hwx1b66 _otyr1b66 _18u01b66"
};
const $5f731770152f321b$export$ff088c0b70bd7288 = ({ extensionNode: extensionNode, isInEditor: isInEditor })=>{
    const { parameters: parameters } = extensionNode;
    const { items: items, styles: styles } = parameters;
    const { experienceSuccessComponent: experienceSuccessComponent, isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const { getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor, getDarkModeCompatibleTextColor: getDarkModeCompatibleTextColor } = (0, $jIDse.useDarkModeColors)(isSSRProductInDarkMode);
    const fillColor = getDarkModeCompatibleBackgroundColor(styles.fillColor);
    const textColor = getDarkModeCompatibleTextColor(styles.textColor);
    const highlightColor = getDarkModeCompatibleTextColor(styles.highlightColor);
    const ExperienceSuccessComponent = experienceSuccessComponent || (0, $cozmU.Fragment);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "links-menu-extension",
        style: (0, $3854be2903fd20e9$export$4a96f3bbfd95cbd4)({
            ...styles,
            fillColor: fillColor
        }, isCornerRadiusEnabled),
        className: (0, $hekY6.default)([
            $5f731770152f321b$var$defaultStyles.itemsWrapper,
            isInEditor && $5f731770152f321b$var$defaultStyles.editorStyles
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $c2cb3287f5634ca1$export$4501b8c967503aa), {
        highlightColor: highlightColor,
        items: items,
        textColor: textColor
    }), /*#__PURE__*/ $cozmU.createElement(ExperienceSuccessComponent, null));
};
module.exports["extensionHasParams"] = $5f731770152f321b$export$9ffe29f134ccd6e9;
module.exports["LinksMenuContent"] = $5f731770152f321b$export$ff088c0b70bd7288;

});


//# sourceMappingURL=links-menu-extension.845b3cb6.js.map
